module.exports = __webpack_public_path__ + "static/image/history/pc/202312.ver2_0_2.jpg?b213758f";